module.exports = __webpack_public_path__ + "assets/img/13.4077be42.png";